<template>
  <div class="app-header-loading"></div>
  <div class="app-sidemenu-layout">
    <Header :showSwaggerButton=true />
    <div class="app-sidemenu">
      <div class="app-sidemenu-close">&times;</div>
      <div class="app-sidemenu-header">
        <div class="app-sidemenu-toggle">
          <i class="fa fa-bars"></i>
        </div>
        <a class="app-header-app-name" href="/">
          <img src="/android-chrome-192x192.png" style="width: 22px" />
          Pamarin Developers
        </a>
      </div>
      <div class="app-sidemenu-body">
        <div class="app-api-version">
          <select class="form-control">
            <option value="v1">API Version 1.0</option>
          </select>
        </div>
        <vue-markdown :source="sideMenu" :html="true" />
      </div>
    </div>
    <div class="app-container">
      <div class="container">
        <document-markdown :text="text" />
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
import axios from "axios";
import Header from "@/layout/Header.vue";
import Footer from "@/layout/Footer.vue";
import VueMarkdown from "vue3-markdown-it";
import DocumentMarkdown from "@/components/DocumentMarkdown.vue";
import hljs from "../hljs";

const setWindowScrollTo = (elementId) => {
  if (elementId && elementId.length) {
    let max = 3000;
    const id = elementId.replace(/#/gi, "");
    const selector = ".app-document-content [data-id=" + id + "]";
    const interval = setInterval(() => {
      const el = document.querySelector(selector);
      if (el) {
        clearInterval(interval);
        const yOffset = -65;
        const y = el.getBoundingClientRect().top + window.pageYOffset + yOffset;
        const t = setTimeout(() => {
          clearTimeout(t);
          window.scrollTo({ top: y });
        }, 15);
      }
      max = max - 50;
      if (max <= 0) {
        clearInterval(interval);
      }
    }, 100);
  }
};

const getElementHeight = (selector) => {
  try {
    return document.querySelector(selector).clientHeight + 1;
  } catch (e) {
    return 0;
  }
};

const updateDocumentSideMenuHeight = () => {
  const sideMenu = document.querySelector(".app-document-sidemenu");
  const windowWidth = window.innerWidth;
  if (windowWidth >= 768) {
    const headerHeight = getElementHeight(".app-haeder");
    const footerHeight = getElementHeight(".app-footer");
    let windowHeight = window.innerHeight - headerHeight;
    let maxHeight = document.body.clientHeight - window.scrollY - footerHeight;
    if (windowHeight > maxHeight) {
      windowHeight = maxHeight;
      const t = setTimeout(() => {
        clearTimeout(t);
        sideMenu.scrollTo({ top: 100000 });
      }, 50);
    }
    sideMenu.style.height = windowHeight + "px";
  } else {
    sideMenu.style.height = "auto";
  }
};

const scrollUpdateDocumentSideMenuHeight = () => {
  const a = document.body.clientHeight - window.scrollY;
  const b = window.innerHeight;
  if (a / b <= 2) {
    updateDocumentSideMenuHeight();
  } else {
    if (window.scrollY === 0) {
      const sideMenu = document.querySelector(".app-document-sidemenu");
      sideMenu.scrollTo({
        top: 0,
      });
    }
  }
};

const tableResponsive = () => {
  const tables = document.querySelectorAll("table:not(.hljs, .hljs-ln)");
  tables.forEach((el) => {
    const wrapper = document.createElement("div");
    wrapper.className = "table-responsive";
    el.parentNode.insertBefore(wrapper, el);
    wrapper.appendChild(el);
  });
};

const removeCssClassName = (classNames, className) => {
  const arr = (classNames || "").split(/\s+/gi);
  if (!(arr && arr.length)) {
    return "";
  }
  return arr.map((c) => c.trim()).filter((c) => c !== className);
};

const handleSideMenuExpandClick = (icon, subMenu) => {
  icon.addEventListener("click", () => {
    let isExpand = icon.getAttribute("data-expand") === "true";
    icon.setAttribute("data-expand", !isExpand);
    subMenu.setAttribute("data-expand", !isExpand);
  });
};

const setDataExpandToSideMenuChildren = (li, expand) => {
  const children = li.children;
  const len = children.length;
  for (let i = 0; i < len; i++) {
    const child = children[i];
    const tagName = child.tagName;
    if (tagName === "UL" || tagName === "I") {
      child.setAttribute("data-expand", expand);
    }
  }
};

const setUpSideMenu = (sideMenus) => {
  const len = sideMenus.length;
  for (let i = 0; i < len; i++) {
    //
    let a = sideMenus[i];
    const li = a.parentElement;
    a.className = removeCssClassName(a.className, "active");
    li.className = removeCssClassName(li.className, "active");
    //
    if (li.tagName === "LI") {
      const ul = li.querySelector("ul");
      if (ul) {
        let icon = li.querySelector(".app-sidemenu-expand");
        if (!icon) {
          icon = document.createElement("i");
          icon.className = "fa app-sidemenu-expand";
          handleSideMenuExpandClick(icon, ul);
          li.appendChild(icon);
        }
        setDataExpandToSideMenuChildren(li, false);
      }
    }
  }
};

const activeSideMenu = () => {
  const interval = setInterval(() => {
    const sideMenus = document.querySelectorAll(".app-sidemenu a:not(.btn)");
    if (sideMenus && sideMenus.length) {
      clearInterval(interval);
      setUpSideMenu(sideMenus);

      const len = sideMenus.length;
      for (let i = 0; i < len; i++) {
        let el = sideMenus[i];
        const href = el.getAttribute("href");
        if (href === location.pathname) {
          el.className += " active";
          while (el.tagName !== "BODY") {
            el = el.parentElement;
            if (el.tagName === "LI") {
              el.className += " active";
              setDataExpandToSideMenuChildren(el, true);
            }
          }
          break;
        }
      }
    }
  }, 50);
};

const setFooterPreviousNext = (path) => {
  const sideMenus = Array.from(
    document.querySelectorAll(".app-sidemenu-body li a")
  ).map((a) => {
    return {
      el: a,
      href: a.getAttribute("href"),
      name: (a.innerText || "").trim(),
    };
  });

  const len = sideMenus.length;
  for (let i = 0; i < len; i++) {
    if (path === sideMenus[i].href) {
      const previous = sideMenus[i - 1];
      const next = sideMenus[i + 1];

      const prevElement = document.querySelector(".app-document-previous");
      const prevParentElement = prevElement.parentElement;
      prevElement.innerHTML = "";
      prevParentElement.style.visibility = "hidden";

      const nextElement = document.querySelector(".app-document-next");
      const nextParentElement = nextElement.parentElement;
      nextElement.innerHTML = "";
      nextParentElement.style.visibility = "hidden";

      if (previous) {
        const a = document.createElement("a");
        a.setAttribute("href", previous.href);
        a.innerText = previous.name;
        prevElement.appendChild(a);
        prevParentElement.style.visibility = "visible";
        prevParentElement
          .querySelector("a")
          .setAttribute("href", previous.href);
      }

      if (next) {
        const a = document.createElement("a");
        a.setAttribute("href", next.href);
        a.innerText = next.name;
        nextElement.appendChild(a);
        nextParentElement.style.visibility = "visible";
        nextParentElement.querySelector("a").setAttribute("href", next.href);
      }
      break;
    }
  }
};

const findBreadcrumbsMenus = () => {
  const sideMenus = document.querySelectorAll(".app-sidemenu a");
  const len = sideMenus.length;
  let list = [];
  for (let i = 0; i < len; i++) {
    let el = sideMenus[i];
    const href = el.getAttribute("href");
    if (href === location.pathname) {
      while (el.tagName !== "BODY") {
        el = el.parentElement;
        if (el.tagName === "LI") {
          const link = el.querySelector("a");
          list = [
            {
              href: link.getAttribute("href"),
              text: link.innerText,
              type: "member",
            },
          ].concat(list);
        } else if (el.tagName === "UL") {
          const sibling = el.previousElementSibling;
          const isHeader = /^H/gi.test(sibling.tagName);
          if (isHeader) {
            list = [
              {
                href: "",
                text: sibling.innerText,
                type: "header",
              },
            ].concat(list);
            break;
          }
        }
      }
      break;
    }
  }
  return list;
};

const createBreadcrumbsItem = (menu) => {
  const li = document.createElement("li");
  const a = document.createElement("a");
  const icon = document.createElement("i");
  const text = document.createTextNode(menu.text);
  //setup
  a.className = menu.type;
  icon.className = "fa fa-chevron-right";
  a.setAttribute("href", menu.href);
  //append
  a.appendChild(icon);
  a.appendChild(text);
  li.appendChild(a);
  return li;
};

const createBreadcrumbs = () => {
  const t = setTimeout(() => {
    clearTimeout(t);

    const menus = findBreadcrumbsMenus();
    const breadcrumbs = document.querySelector(".app-document-breadcrumbs");
    breadcrumbs.innerHTML = "";

    const ul = document.createElement("ul");
    const length = menus.length;
    for (let i = 0; i < length; i++) {
      const li = createBreadcrumbsItem(menus[i]);
      ul.appendChild(li);
    }
    breadcrumbs.appendChild(ul);
    breadcrumbs.setAttribute("data-count", length);

    const span = document.createElement("span");
    span.style.clear = "both";
    breadcrumbs.appendChild(span);
  }, 50);
};

export default {
  components: {
    Header,
    Footer,
    VueMarkdown,
    DocumentMarkdown,
  },
  data() {
    return {
      text: "",
      sideMenu: "",
      currentContext: this.$route.params.context || "overview",
      currentVersion: this.$route.params.version,
      currentDocument: this.$route.params.document,
      scrollDebounce: null,
      documentMenus: [],
      documentCached: {},
      latestScroll: 0,
    };
  },
  mounted() {
    const params = this.$route.params;
    this.loadSideMenu(params.version);
    this.loadDocument(
      params.context || "overview",
      params.version,
      params.document
    );
    window.addEventListener("scroll", this.activeDocumentMenu);
    window.addEventListener("scroll", scrollUpdateDocumentSideMenuHeight);
    window.addEventListener("resize", updateDocumentSideMenuHeight);

    const t = setTimeout(() => {
      clearTimeout(t);
      setWindowScrollTo(this.$route.hash);
    }, 500);
  },
  unmounted() {
    window.removeEventListener("scroll", this.activeDocumentMenu);
    window.removeEventListener("scroll", scrollUpdateDocumentSideMenuHeight);
    window.removeEventListener("resize", updateDocumentSideMenuHeight);
  },
  watch: {
    "$route.params"() {
      const params = this.$route.params;
      const context = params.context || "overview";
      const version = params.version;
      const document = params.document;

      const sameOldParams =
        this.currentContext === context &&
        this.currentVersion === version &&
        this.currentDocument === document;

      if (!sameOldParams) {
        this.currentContext = context;
        this.currentVersion = version;
        this.currentDocument = document;
        window.scrollTo({ top: this.latestScroll });
        this.latestScroll = 0;
        this.loadDocument(context, version, document);
      }

      setWindowScrollTo(this.$route.hash);
    },
  },
  methods: {
    loadSideMenu(version) {
      if (version && version.length) {
        axios
          .get(`/th/docs/overview/${version}/side-menu.md`)
          .then((resp) => {
            this.sideMenu = resp.data;
          })
          .catch(() => {
            this.sideMenu = "";
          });
      }
    },
    loadDocument(context, version, documentId) {
      if (
        context &&
        context.length &&
        version &&
        version.length &&
        documentId &&
        documentId.length
      ) {
        const cachedObject = this.documentCached[
          `/${context}/${version}/${documentId}`
        ];
        if (!cachedObject) {
          const url =
            context === "overview"
              ? `/th/docs/overview/${version}/${documentId}.md`
              : `/th/docs/references/${context}/${version}/${documentId}.md`;
          axios
            .get(url)
            .then((resp) => {
              this.text = resp.data;
              this.createDocumentMenu();
            })
            .catch(() => {
              this.text = "Not found";
            });
        } else {
          this.text = cachedObject.text;
          this.createDocumentMenu();
        }
      }
    },
    createDocumentMenu() {
      //clear cache
      this.documentMenus = [];

      const documentMenu = document.querySelector(".app-document-menu");
      if (documentMenu) {
        documentMenu.innerHTML = "";

        const timeout = setTimeout(() => {
          clearTimeout(timeout);

          const selector = [
            ".app-document-content h1 a",
            ".app-document-content h2 a",
            ".app-document-content h3 a",
          ].join(", ");

          const headerLinks = document.querySelectorAll(selector);

          if (headerLinks.length) {
            //h3
            const h3 = document.createElement("h3");
            h3.innerText = "Table of Contents";
            documentMenu.appendChild(h3);

            const fa = document.createElement("i");
            fa.className = "fa fa-list";
            h3.prepend(fa);

            //ul
            const ul = document.createElement("ul");
            const len = headerLinks.length;
            for (let i = 0; i < len; i++) {
              const el = headerLinks[i];

              //link icon
              const linkIcon = document.createElement("i");
              linkIcon.className = "fa fa-link";
              el.appendChild(linkIcon);

              const href = el.getAttribute("href");
              const id = href.replace(/#/gi, "");
              const parent = el.parentElement;
              parent.setAttribute("data-id", id);

              if (parent.tagName === "H1") {
                document.title = el.innerText + " - Pamarin Developers";
              }

              //a
              const a = document.createElement("a");
              a.setAttribute("href", href);
              a.innerText = el.innerText;

              //li
              const li = document.createElement("li");
              li.className = "app-document-menu--" + parent.tagName;
              li.setAttribute("data-id", id);
              li.appendChild(a);

              //save cache

              this.documentMenus.push({
                id: id,
                el: li,
                $ref: el,
                href: href,
                offsetTop: 0,
              });

              ul.appendChild(li);
            }

            documentMenu.appendChild(ul);
          }

          activeSideMenu();
          createBreadcrumbs();
          setFooterPreviousNext(this.$route.path);
          tableResponsive();

          //Re-offset position
          const t = setTimeout(() => {
            clearTimeout(t);
            for (let i = 0; i < this.documentMenus.length; i++) {
              const documentMenu = this.documentMenus[i];
              const newOffsetTop = (documentMenu.$ref.offsetTop || 0) - 25;
              documentMenu.offsetTop = newOffsetTop;
            }
            this.activeDocumentMenu();
            updateDocumentSideMenuHeight();
          }, 300);

          //cached object
          const params = this.$route.params;
          const context = params.context;
          const version = params.version;
          const documentId = params.document;

          this.documentCached[`/${context}/${version}/${documentId}`] = {
            title: document.title,
            text: this.text,
          };
        }, 100);

        hljs.init();

        window.scrollTo({ top: 0 });
      }
    },
    activeDocumentMenu() {
      this.latestScroll = window.scrollY;

      if (this.scrollDebounce) {
        clearTimeout(this.scrollDebounce);
      }

      this.scrollDebounce = setTimeout(() => {
        clearTimeout(this.scrollDebounce);

        const scrollTop = window.scrollY;

        this.documentMenus.forEach((item) => {
          item.el.className = removeCssClassName(item.el.className, "active");
        });

        const len = this.documentMenus.length;
        for (let i = 0; i < len; i++) {
          const item = this.documentMenus[i];
          const offsetTop = parseInt(item.offsetTop, 10);
          if (scrollTop <= offsetTop) {
            const index = i === 0 ? 0 : i - 1;
            this.documentMenus[index].el.className += " active";
            break;
          }
        }
      }, 30);
    },
  },
};
</script>

<style scoped>
.app-api-version {
  margin-bottom: 1rem;
}

.app-api-version select {
  width: 100%;
  height: 32px;
  color: #8c9094;
}
</style>